import { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { PRODUCTS } from "@/data/site";
import { PRODUCT_CONFIGS } from "@/data/productConfigs";
import ProductPage from "@/components/product/ProductPage";
import { AcadmaxLoginNote } from "@/components/product/AcadmaxLoginNote";
import Seo, { breadcrumbLd, productLd } from "@/components/seo/Seo";

const PROD_KEYWORDS = {
  "acadmax-erp": "campus ERP, university ERP, school management system, higher education ERP, Acadmax, admissions software, exam management, HR payroll ERP, Pakistan ERP, UK EdTech, UAE education software",
  "libmax": "library management system, LMS software, digital library platform, RFID library, university library Pakistan, LMS UK, Libmax",
  "unicrm-ai": "admissions CRM, university CRM, student recruitment CRM, education CRM, AI admissions software, UniCRM, WhatsApp CRM, admissions BPO",
  "visainterviews-ai": "visa interview practice, CAS Shield interview, credibility interview AI, visa mock interview, student visa preparation, UK visa interview",
  "teachingsoftware-ai": "AI teaching assistant, tutor software, AI lesson planner, online tuition platform, teaching OS, TeachingSoftware.ai",
  "hellosir-ai": "AI concierge, AI voice agent, AI chatbot, AI customer service, WhatsApp AI agent, HelloSir",
};

export default function ProductDetail() {
  const { slug } = useParams();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [slug]);

  const config = PRODUCT_CONFIGS[slug];
  if (config) {
    return (
      <>
        <Seo
          title={config.name}
          description={config.hero.subtitle}
          keywords={PROD_KEYWORDS[slug]}
          image={config.hero_image || config.brand?.hero}
          type="website"
          jsonLd={[
            productLd({
              name: config.name,
              description: config.hero.subtitle,
              slug,
              image: config.hero_image || config.brand?.hero,
              url: config.external_url,
            }),
            breadcrumbLd([
              { name: "Home", path: "/" },
              { name: "Products", path: "/products" },
              { name: config.name, path: `/products/${slug}` },
            ]),
          ]}
        />
        <ProductPage config={config} />
        {slug === "acadmax-erp" && <AcadmaxLoginNote />}
      </>
    );
  }

  const p = PRODUCTS.find((x) => x.slug === slug);
  if (!p) {
    return (
      <div className="max-w-3xl mx-auto px-6 py-40 text-center">
        <Seo title="Product not found" noindex />
        <h1 className="font-heading font-bold text-3xl">Product not found</h1>
        <Link to="/products" className="mt-4 inline-block text-primary">Back to products</Link>
      </div>
    );
  }

  return (
    <div data-testid="product-detail-page" className="max-w-5xl mx-auto px-6 py-24">
      <Seo title={p.name} description={p.tagline} />
      <Link to="/products" className="text-xs font-mono uppercase tracking-[0.2em] text-muted-foreground hover:text-primary">← All products</Link>
      <h1 className="mt-6 font-heading font-black tracking-tight text-5xl">{p.name}</h1>
      <p className="mt-4 text-lg text-muted-foreground max-w-2xl">{p.tagline}</p>
      <p className="mt-4 max-w-2xl text-foreground/80">{p.description}</p>
    </div>
  );
}
